import { render, staticRenderFns } from "./IconCategories.vue?vue&type=template&id=109a8a92&scoped=true"
import script from "./IconCategories.vue?vue&type=script&lang=js"
export * from "./IconCategories.vue?vue&type=script&lang=js"
import style0 from "./IconCategories.vue?vue&type=style&index=0&id=109a8a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109a8a92",
  null
  
)

export default component.exports